import React from 'react'
import {Link} from 'react-router'
import {FormattedMessage} from 'react-intl'
import {connect} from 'react-redux'
import {individualEstateRegister, batchEstatesRegister, profile, landingPageUrl, login, logout} from 'conf'

import LanguageMenu from './LanguageMenu'
import togglePreferencesModal from '../actions/togglePreferencesModal'
import getCurrentEncodedUrl from '../utils/getCurrentEncodedUrl'

const Menu = ({userName, isLoggedIn, lang, encodedLocationUrl, onTogglePreferencesModal, showAnnonceDropdown, showUserDropdown, toggleAnnonceDropdown, toggleUserDropdown}) => {

  const onClick = () => {
    let url = getCurrentEncodedUrl();
    window.location.href = login(lang, url);
  }

  const loginButton =
        <li>
          <a onClick={onClick}>
            <FormattedMessage
              id="Login"
              defaultMessage="Login" />
          </a>
        </li>

  const logoutButton = 
        <li className={`dropdown ${showUserDropdown ? 'open' : ''}`} onMouseEnter={toggleUserDropdown} onMouseLeave={toggleUserDropdown}>
          <a>
            {userName}
            <span className="caret"></span>
          </a>
          <ul className="dropdown-menu" style={{zIndex:'2000'}}>
            <li>
              <a href={profile(userName, lang)}>
                <FormattedMessage id="Profile" defaultMessage="Profile"/>
              </a>
            </li>
            <li>
              <a href={logout(lang)}>
                <FormattedMessage id="Logout" defaultMessage="Logout" />
              </a>
            </li>
          </ul>
        </li>

   const announceButton =
        <li className={`dropdown ${showAnnonceDropdown ? 'open' : ''}`} onMouseEnter={toggleAnnonceDropdown} onMouseLeave={toggleAnnonceDropdown}>
          <a>
            <FormattedMessage id="Annonce" defaultMessage="Annonce"/>
            <span className="caret"></span>
          </a>
          <ul className="dropdown-menu" style={{zIndex:'2000'}}>
            <li>
              <a href={individualEstateRegister(lang)}>
                <FormattedMessage id="One estate" defaultMessage="One estate"/>
              </a>
            </li>
            <li>
              <a href={batchEstatesRegister(lang)}>
                <FormattedMessage id="Multiple estates" defaultMessage="Multiple estates"/>
              </a>
            </li>
          </ul>
        </li>

  const rootLink = "/?lang=" + lang;

  return <nav className="navbar navbar-default navbar-inverse">
    <div className="collapse navbar-collapse">
      <ul className="nav navbar-nav">
        <li className="signature">
          <a href={rootLink}>
              <img style={{height:"30px"}}src="images/logo/ouhabiter.svg"/>
              {' '} OùHabiter.ca
          </a>
        </li>
      </ul>
      <ul className="nav navbar-nav navbar-right">
        <LanguageMenu />
        <li>
          <a onClick={onTogglePreferencesModal}>
            <FormattedMessage id="Preferences" defaultMessage="Preferences"/>
          </a>
        </li>
        {isLoggedIn ? logoutButton : loginButton}
        {announceButton}
      </ul>
    </div>
  </nav>
}

export const StatelessMenu = Menu

const mapStateToProps = (state) => {
  return {
    isLoggedIn: !!state.session.token,
    userName: state.session.userName,
    lang: state.lang,
    encodedLocationUrl: state.encodedLocationUrl,
    showAnnonceDropdown: state.show.annonceDropdown,
    showUserDropdown: state.show.userDropdown,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onTogglePreferencesModal:  _ => dispatch(togglePreferencesModal()),
    toggleUserDropdown: _ => dispatch({type:'toggle_user_dropdown'}),
    toggleAnnonceDropdown: _ => dispatch({type:'toggle_annonce_dropdown'}),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Menu)



/** WEBPACK FOOTER **
 ** ./app/components/Menu.jsx
 **/